<template>
  <v-tabs
    background-color="#263238"
    dark
    show-arrows
    slider-color="#263238"
    class="mb-4 rounded-lg"
  >
    <v-tab to="/admin/timelines/transfer_directors">
      <v-icon left small>mdi-calendar</v-icon>กำหนดการ
    </v-tab>

    <v-tab to="/admin/transference_manage_main">
      <v-icon left small>mdi-details</v-icon>ผู้เสนอย้ายสายบริหาร
    </v-tab>

    <v-tab to="/admin/transference_manage_location_detail">
      <v-icon left small>mdi-details</v-icon>รายละเอียดผู้ยื่นย้าย (ประมวลผลแบบที่ 1)
    </v-tab>

    <v-tab to="/admin/transference_manage_location_college">
      <v-icon left small>mdi-office-building-marker</v-icon>รายละเอียดวิทยาลัยปลายทาง (ประมวลผลแบบที่ 2)
    </v-tab>

    <v-tab to="/admin/transference_manage_auto_match">
      <v-icon left small>mdi-robot</v-icon>ประมวลผลย้ายอัตโนมัติ
    </v-tab>

    <v-tab to="/admin/transference_manage">
      <v-icon left small>mdi-calculator</v-icon>ผลการพิจารณา กลั่นกรอง
    </v-tab>

    <v-tab to="/admin/transference_manage_report">
      <v-icon left small>mdi-calculator</v-icon>บทสรุป
    </v-tab>

    <v-tab to="/admin/conditons_transfer_success_reportmv_director">
      <v-icon left small>mdi-file-document-check-outline</v-icon>ติดตามการรายงานตัว
    </v-tab>
  </v-tabs>
</template>

<script>
export default {
  name: "HRvecTransferenceManagebar"
};
</script>
